import { useAuth } from '../../../contexts/auth'
import { Button } from '../../../components/button'

export default function UpdateEmailRequestSuccess({ onClose }) {
  const [{ userDetails }] = useAuth()

  return (
    <div className='wrapper'>
      <h1 className='title'>Check your email!</h1>
      <p className='confirmation'>
        We have sent a confirmation to
        <br />
        <span className='email'>{userDetails.email}</span>
      </p>
      <p className='description'>
        Please follow the link within the email to confirm your account and continue.
      </p>
      <Button className='resendBtn' onClick={onClose}>
        Close
      </Button>

      <style jsx>{`
        .wrapper {
          position: relative;
          min-width: 43.6rem;
          max-width: 90rem;
          padding: 2.6rem 0 4.1rem;
          background: #fff;
          border-radius: 1rem;

          :global(.resendBtn) {
            display: block;
            margin: 0 auto;
          }
        }

        .title {
          text-align: center;
          font-size: 3.2rem;
        }

        .confirmation {
          margin: 0.7rem auto 2.6rem;
          text-align: center;
          font-size: 1.6rem;

          .email {
            color: var(--text-link-color);
            margin: 2.6rem;
            word-wrap: break-word;
          }
        }

        .description {
          max-width: 26.6rem;
          margin: 0.7rem auto 2.6rem;
          text-align: center;
          font-size: 1.6rem;
        }

        @media (max-width: 1024px) {
          .wrapper {
            width: 100%;
            height: 100%;
            padding: 1.6rem 0 2.3rem;

            :global(.resendBtn) {
              position: fixed;
              bottom: 2.1rem;
              left: 1.2rem;
              width: calc(100vw - 2.4rem);
            }
          }
        }
      `}</style>
    </div>
  )
}
